export const CREATE_NOTIFICATION_SUCCESS = 'CREATE_NOTIFICATION_SUCCESS';
export const CLEAR_NOTIFICATION_SUCCESS = 'CLEAR_NOTIFICATION_SUCCESS';

const NOTIFICATION_CLEARING_DELAY = 5000; // in milliseconds

const createNotificationSuccess = data => ({
  type: CREATE_NOTIFICATION_SUCCESS,
  messages: data
});

const clearNotificationSuccess = () => ({
  type: CLEAR_NOTIFICATION_SUCCESS,
  error: false
});

export const createNotification = messages => dispatch => {
  dispatch(createNotificationSuccess(messages));
  setTimeout(
    () => dispatch(clearNotificationSuccess()),
    NOTIFICATION_CLEARING_DELAY
  );
};

export const clearNotification = () => dispatch =>
  dispatch(clearNotificationSuccess);



// WEBPACK FOOTER //
// ./src/actions/notifications.js